<template>
  <account-modal class="block-account-modal">
    <template slot="heading">
      <template>Block account<template v-if="account.hasName">&nbsp;“{{ account.name }}”</template>?</template>
      <fee-account-label v-if="account.isUsedForFee" />
      <vault-wallet-label v-if="account.isVaultAccount" />
    </template>

    <template slot="content">
      <p class="mb-2">Please, confirm that you want to disable account<template v-if="account.hasName">&nbsp;<b>“{{ account.name }}”</b></template>. Note that:</p>

      <ul>
        <li>nobody will be able to send money to this account;</li>
        <li>neither you nor the client will be able to top up blocked account or make transfers from it;</li>
        <li>if there are funds it will be frozen.</li>
      </ul>

      <v-text-field
        v-model="form.reason"
        max-length="1000"
        label="Reason for account blocking"
        placeholder="Please, provide reason why you’re blocking this account"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('reason')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onBlockButtonClick"
      >block</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Mixins
  import form from '@/mixins/form'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import FeeAccountLabel from '@/components/accounts/FeeAccountLabel'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'BlockAccountModal',
    components: {
      AccountModal,
      FeeAccountLabel,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        accountBlockApiRequest: new ApiRequest(AccountApi.block),
        form: { reason: null },
        requiredFields: ['reason']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.profileId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.accountBlockApiRequest.loading
      },
      error () {
        return this.accountBlockApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onBlockButtonClick () {
        this.accountBlockApiRequest
          .execute(this.account.accountId, this.form.reason)
          .then(this.accountBlockSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountBlockSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been successfully blocked.' }
          })
        }, 100)
      }
    }
  }
</script>
